// @ts-nocheck — bridges JS-era NotificationManager callbacks into Notifications.
import React, { useCallback, useEffect, useState } from "react";
import NotificationManager from "./NotificationManager";
import Notifications from "./Notifications";

function NotificationContainer({
  enterTimeout = 400,
  leaveTimeout = 400
}) {
  const [notifications, setNotifications] = useState([]);

  const handleStoreChange = useCallback(next => {
    setNotifications(next);
  }, []);

  useEffect(() => {
    NotificationManager.addChangeListener(handleStoreChange);
    return () => {
      NotificationManager.removeChangeListener(handleStoreChange);
    };
  }, [handleStoreChange]);

  const handleRequestHide = useCallback(notification => {
    NotificationManager.remove(notification);
  }, []);

  return (
    <Notifications
      enterTimeout={enterTimeout}
      leaveTimeout={leaveTimeout}
      notifications={notifications}
      onRequestHide={handleRequestHide}
    />
  );
}

export default NotificationContainer;
